import React,{useEffect, useRef} from 'react'

import { useState } from 'react'
import CompanyForm from '../components/CompanyForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';

import { Print } from '@mui/icons-material';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';




const CellActions = (props) =>{
    return(
        <>
            <CompanyForm  callBack={props.callBack} data={props.data} />
            {/* <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog> */}
        </>
    )
  }


function CompanyDashboardPage() {

  
  const {companyList,getCompanyList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"companyName",headerName: "Company Name",width:250},
        {field:"gst",headerName: "GST",width:250},
        {field:"phone",headerName: "Phone"},
        {field:"email",headerName: "Email"},
        {field:"city",headerName: "City"},
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getCompanyList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Company</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><CompanyForm callBack={getCompanyList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={companyList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getCompanyList}
              />
            </div>
          </div>
        </div>
    </FinanceLayout>
    
  )
}

export default CompanyDashboardPage